

export class StateUpdateInput implements IStateUpdateInput {
    /** The auto-generated id of the state master */
    stateId!: number;
    /** The state name with 255 character limit */
    stateName!: string;

    constructor(data?: IStateUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stateId = _data["stateId"];
            this.stateName = _data["stateName"];
        }
    }

    static fromJS(data: any): StateUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new StateUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stateId"] = this.stateId;
        data["stateName"] = this.stateName;
        return data; 
    }
}

export interface IStateUpdateInput {
    /** The auto-generated id of the state master */
    stateId: number;
    /** The state name with 255 character limit */
    stateName: string;
}

